export default "__VITE_ASSET__c9dac0b9__"